<script lang="ts">
	//UI
	import MultiplePageLayout from "@hitit/hub/src/layouts/MultiplePageLayout.svelte";
	import PointHistory from "./PointHistory.svelte";
	import PointClientList from "./PointClientList.svelte";
	import PointSetting from "./PointSetting.svelte";
	//Utils
	import { navigate, Router, Route } from "svelte-routing";
	import { t } from "@hitit/hub/src/stores";
	//Types
	//Props
	export let storeId = "";
	//Constants
	//Variables
	//Functions
	//Do

	$: headerInfos = [
		{
			title: $t("global.point.pointHistory"),
			clickEvent: () => navigate(`/store/${storeId}/earning/history`),
			route: `/store/${storeId}/earning/history/*`,
		},
		{
			title: $t("global.point.Members"),
			clickEvent: () => navigate(`/store/${storeId}/earning/client`),
			route: `/store/${storeId}/earning/client/*`,
		},
		{
			title: $t("global.Setting"),
			clickEvent: () => navigate(`/store/${storeId}/earning/setting`),
			route: `/store/${storeId}/earning/setting/*`,
		},
	];

</script>

<MultiplePageLayout headerInfos={headerInfos}>
	<Router>
		<Route path="/history">
			<PointHistory storeId={storeId} />
		</Route>
		<Route path="/client">
			<PointClientList storeId={storeId} />
		</Route>
		<Route path="/setting">
			<PointSetting storeId={storeId} />
		</Route>
	</Router>
</MultiplePageLayout>

<style lang="scss">
</style>
